import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Swiftmend",
    "inv_relics_idolofrejuvenation",
    [
      "Consumes a Rejuvenation or Regrowth effect on a friendly target to instantly heal them an amount equal to 12 sec. of Rejuvenation or 18 sec. of Regrowth.",
    ],
    1,
    [[1]],
    [
      {
        x: 3,
        y: 1,
      },
    ],
    null,
    "20% of base mana",
    "40 yd range",
    "Instant",
    "15 sec cooldown"
  ),
  null,
  null,
];

export default tier7;
